const autoNgTemplateLoaderTemplate1 = require('./init-license.view.html');

import controller from './init-license.view.controller.js';

angular.module('portainer.app').component('initLicenseView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
